import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLists, ListData } from '../repository/listRepository';

export const ListOfLists: React.FC = () => {
  const [lists, setLists] = useState<ListData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLists()
      .then(setLists)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">My Lists</h1>
        <Link to="/lists/new" className="btn btn-primary">New List</Link>
      </div>

      {lists.length === 0 ? (
        <div className="empty-state">
          <p>No lists yet.</p>
          <Link to="/lists/new" className="btn btn-primary">Create your first list</Link>
        </div>
      ) : (
        <div className="list-grid">
          {lists.map(list => (
            <Link to={`/lists/${list.uuid}`} key={list.uuid} className="list-card">
              <div className="list-card-name">{list.name}</div>
              <div className="list-card-meta">
                {list.list_type} &middot; updated {new Date(list.updated_at).toLocaleDateString()}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
